var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.40078C0 1.51713 0.716344 0.800781 1.6 0.800781H14.4C15.2837 0.800781 16 1.51713 16 2.40078V11.2008C16 12.0844 15.2837 12.8008 14.4 12.8008H10.7314L8.56569 14.9665C8.25327 15.2789 7.74673 15.2789 7.43431 14.9665L5.26863 12.8008H1.6C0.716344 12.8008 0 12.0844 0 11.2008V2.40078ZM14.4 2.40078H1.6V11.2008H5.6C5.81217 11.2008 6.01566 11.2851 6.16569 11.4351L8 13.2694L9.83432 11.4351C9.98434 11.2851 10.1878 11.2008 10.4 11.2008H14.4V2.40078Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 8.40078C3.2 7.95895 3.55817 7.60078 4 7.60078H8.8C9.24183 7.60078 9.6 7.95895 9.6 8.40078C9.6 8.84261 9.24183 9.20078 8.8 9.20078H4C3.55817 9.20078 3.2 8.84261 3.2 8.40078Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 5.20078C3.2 4.75895 3.55817 4.40078 4 4.40078H12C12.4418 4.40078 12.8 4.75895 12.8 5.20078C12.8 5.64261 12.4418 6.00078 12 6.00078H4C3.55817 6.00078 3.2 5.64261 3.2 5.20078Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/SMSIcon.80baa7ec3384dcbdb311178da2f85b40.svg";
export { ForwardRef as ReactComponent };